import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import Stepper from 'react-stepper-horizontal';
import ld from 'lodash';
import * as ProjectTypeActionType from 'Projects/constants';
import emptyImages from 'assets/img/empty-images.svg';
import emptyFolderIcon from 'assets/img/folder.png';
import exclamation_circle from 'assets/img/exclamation-circle.svg';

export class ItemImport extends React.Component {
  static propTypes = {
    itemArray: PropTypes.array,
    projectId: PropTypes.string,
    exposeRef: PropTypes.func,
    dispatch: PropTypes.func,
    breadcrumbs: PropTypes.string,
    breadcrumbsHistory: PropTypes.string,
    isVisibleStepper: PropTypes.bool,
    selectedInventories: PropTypes.array,
    goBack: PropTypes.func
  }

  constructor(props) {
    super(props);

    this.emptyInventoryName = ' ';
    this.alternateName = '[No Name]';

    this.state = {
      checkedItemArray: [],
      hideItems: [],
      groupItem: {},
      steps: [{
        title: 'Import inventory',
        onClick: (e) => {
          e.preventDefault();
        }
      }, {
        title: 'Import inventory items',
        onClick: (e) => {
          e.preventDefault();
        }
      }],
      currentStep: 1,
      searchText: ''
    };

    this.props.exposeRef(this);
    this.breadcrumbs = [
      { title: 'Inventory items', url: '/', onCustomAction: this.props.goBack },
      { title: 'Import inventory item', url: '' }
    ];
  }

  componentDidMount() {
    this.getTemplateItemList();
  }

  componentWillReceiveProps(nextProps) {
    let newItemArray = nextProps.itemArray;
    let tt = ld.reduce(newItemArray, (result, value) => {
      if (value.categoryNames.length === 0) {
        value.categoryNames.push(this.emptyInventoryName);
      }

      ld.reduce(value.categoryNames, (r, v) => {
        (r[v] || (r[v] = [])).push(value);
        return r;
      }, result);

      return result;
    }, {});

    this.setState({groupItem: tt});
  }

  //#region Event Handler
  isChecked(templateId, groupName) {
    let index = this.state.checkedItemArray.findIndex(e => { return e.id === templateId; });

    if (index !== -1) {
      return this.state.checkedItemArray[index].categoryNames.findIndex(e => { return e === groupName; }) > -1;
    }

    return false;
  }

  onCheckInventoryTemplate(templateId, groupName) {
    let index = this.state.checkedItemArray.findIndex(e => { return e.id === templateId; });
    let newArray = [...this.state.checkedItemArray];

    if (index !== -1) {
      let indexName = newArray[index].categoryNames.findIndex(e => { return e === groupName; });

      if (indexName !== -1) {
        newArray[index].categoryNames.splice(indexName, 1);
        if (newArray[index].categoryNames.length === 0) {
          newArray.splice(index, 1);
        }
      }
      else {
        newArray[index].categoryNames.push(groupName);
      }
    }
    else {
      newArray.push({id: templateId, categoryNames: [groupName]});
    }

    this.setState({ ...this.state, checkedItemArray: newArray });
  }

  //#endregion Event Handler

  getTemplateItemList() {
    this.props.dispatch({
      type: ProjectTypeActionType.GET_INVENTORY_ITEM_TEMPLATE_LIST_ASYNC,
      params: {
        projectId: this.props.projectId,
        CategoryNames: this.props.selectedInventories
      }
    });
  }

  submit(callback) {
    let isImportDirect = !(Array.isArray(this.props.selectedInventories) && this.props.selectedInventories.length > 0);

    if (this.state.checkedItemArray.length > 0) {
      this.props.dispatch({
        type: ProjectTypeActionType.POST_INVENTORY_ITEM_TEMPLATE_LIST_ASYNC,
        isImportDirect: isImportDirect,
        params: {
          ProjectId: this.props.projectId,
          InventoryItemTemplates: [...this.state.checkedItemArray]
        },
        callback
      });
    }
    else {
      callback();
    }
  }

  onSearch() {
    let items = [];

    for (var key of Object.keys(this.state.groupItem)) {
      this.state.groupItem[key].map(e => {
        if (!e.name.toLowerCase().includes(this.state.searchText.toLowerCase())) {
          items.push(e.id);
        }
      });
    }

    this.setState({hideItems: items});
  }

  //#region Render
  renderToolTipForCheckbox(isShowTooltip) {
    if (isShowTooltip) {
      return (
        <Tooltip className='tooltip-siteone'>
          <span>This item is already added to this project. Make sure that you still want to add it again.</span>
        </Tooltip>
      );
    }

    return '';
  }

  renderToolTipForName = (name, mfg, model) => {
    return (
      <Tooltip className='tooltip-siteone'>
        {name}<br/>
        <b>MFG</b>: {mfg}<br/>
        <b>Model</b>: {model}
      </Tooltip>
    );
  }

  renderCheckbox(e, groupName) {
    return (
      <CheckBoxSingle
        value={e.id}
        checked={this.isChecked(e.id, groupName)}
        onChecked={() => this.onCheckInventoryTemplate(e.id, groupName)}
      />
    );
  }

  renderItemList(groupName) {
    let items = this.state.groupItem[groupName];

    if (Array.isArray(items)) {
      return (
        items.sort((a,b) => a.name.localeCompare(b.name)).map(e => {
          return (
            this.state.hideItems.indexOf(e.id) === -1 &&
            <React.Fragment>
              <div key={e.id} style={{ marginBottom: 15 }} className='col-md-3 col-xs-6 col-sm-6 col-lg-3'>
                <div className='category-list-items'>
                  <div className='category-list-item-wrapper' style={{position: 'relative'}}>
                    <img style={{ width: '100%', height: 170, objectFit: 'contain' }} src={e.image ? e.image.thumbnailUrl : emptyImages} />
                    {
                      e.isExist &&
                      <OverlayTrigger placement='top' overlay={this.renderToolTipForCheckbox(e.isExist)}>
                        <img style={{top: '10px', right: '10px', position: 'absolute'}} src={exclamation_circle} />
                      </OverlayTrigger>
                    }
                  </div>
                  <div className='category-list-items-project-name'>
                    <div className='col-md-9 col-sm-9'>
                      <OverlayTrigger placement='top' overlay={this.renderToolTipForName(e.name, e.mfg, e.model)}>
                        <div className='category-name' style={{maxWidth: '100%', display: 'inline-block'}}>{e.name}</div>
                      </OverlayTrigger>
                    </div>
                    <div className='category-name col-md-3 col-sm-3' style={{ textAlign: 'right' }}>
                      {this.renderCheckbox(e, groupName)}
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        }));
    }

    return null;
  }

  renderGroup() {
    let keys = Object.keys(this.state.groupItem);

    if (keys.length > 0) {
      return (
        keys.sort((a,b) => a.localeCompare(b)).map(groupName => {
          return (
            this.state.groupItem[groupName].filter(e => {return this.state.hideItems.indexOf(e.id) === -1; }).length > 0 &&
            <div className='row'>
              <div className='col-md-12 col-xs-12'>
                <h4 className='title' style={{ marginTop: 15, marginBottom: 5, fontWeight: 'bold' }}>
                  {groupName === this.emptyInventoryName ? this.alternateName : groupName}
                </h4>
              </div>
              {this.renderItemList(groupName)}
            </div>
          );
        })
      );
    }
    else
    {
      return (
        <div className='row' style={{marginTop: '50px'}}>
          <div style={{textAlign: 'center'}}>
            <img src={emptyFolderIcon} alt='no-files'/>
            <p style={{marginTop: '10px'}}>No files</p>
          </div>
        </div>
      );
    }
  }

  render() {
    const { steps, currentStep } = this.state;

    return (
      <React.Fragment>
        <h4 style={{ height: 30, marginTop: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>Import from Library</h4>
        <div className='row'>
          <div className='col-md-4 col-lg-4 col-sm-6'>
            <Breadcrumb breadcrumbs={this.breadcrumbs} />
          </div>
          <div className='col-md-offset-4 col-md-4 col-lg-4 col-sm-6 float-right'>
            <div className='box-search' style={{ margin: 0, transform: 'translateY(5px)' }}>
              <div className='input-group'>
                <input
                  type='text'
                  id='txt-search-email'
                  value={this.state.searchText}
                  className='form-control'
                  placeholder='Search by name'
                  onChange={e => this.setState({searchText: e.target.value})}
                  onKeyPress={e => { if (e.key === 'Enter') { this.onSearch(); }}} />
                <span className='input-group-btn'>
                  <button
                    style={{ padding: '4px 10px', fontSize: 16, backgroundColor: '#ececec', border: '0.5px solid #d8d8d8', height: 40 }}
                    onClick={this.onSearch.bind(this)}
                    className='btn btn-secondary'>
                    <span className='fa fa-search' aria-hidden='true' />
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
        {
          Array.isArray(this.props.selectedInventories) && this.props.selectedInventories.length > 0 &&
          <div className='row'>
            <div style={{ marginBottom: '30px', width: '400px', top: '-25px', position: 'relative', left: '-20px' }}>
              <Stepper steps={steps} activeStep={currentStep} disabledSteps={[0]} />
            </div>
          </div>
        }
        {
          this.renderGroup()
        }
      </React.Fragment>
    );
  }
  //#endregion Render
}

const mapStateToProps = (state) => {
  return {
    itemArray: state.ProjectStore.InventoryItemTemplateList
  };
};

export default connect(mapStateToProps)(ItemImport);



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/item-import.js